import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'tippy.js/dist/tippy.css';
import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter, Route } from 'react-router-dom';

ReactDOM.render(
  <BrowserRouter>
    <div>
      <Route component={App} />
    </div>
  </BrowserRouter>,
  document.getElementById('root')
);